export const contactUs = [
  {
    value: "Sales",
    label: "Sales",
  },
  {
    value: "Orders",
    label: "Orders",
  },
  {
    value: "General",
    label: "General",
  },
  {
    value: "Marketing",
    label: "Marketing",
  },
  {
    value: "Feedback",
    label: "Feedback",
  },
  {
    value: "Photoshoots",
    label: "Photoshoots",
  },
  {
    value: "Careers",
    label: "Careers",
  },
  {
    value: "Contribution",
    label: "Contribution",
  },
];
